import { fetchGroupsPrograms } from 'actions/Program/Group';
import { getProgramsOptions } from 'src/components/Groups/Programs/utils';
import { crtb1967DeactivatedProgramsInternalCasesFilter } from 'src/common/utils/FeatureFlags/flags';

const fetchPrograms = (groupId, query = null, state) => async (dispatch, getState) => {
  const currentState = getState();
  const includeDeactivatedPrograms = crtb1967DeactivatedProgramsInternalCasesFilter(currentState);
  const programsFilter = { query, ...(!includeDeactivatedPrograms && { active: true }) };

  const { data: { data: programs } } = await dispatch(fetchGroupsPrograms(groupId, programsFilter));

  return getProgramsOptions(programs, state);
};

export default fetchPrograms;
